module.exports = __webpack_public_path__ + "img/LTC-Image.72e9a73b.png";